import { render, staticRenderFns } from "./CustomerPersonalData.vue?vue&type=template&id=daa4d432&scoped=true&"
import script from "./CustomerPersonalData.vue?vue&type=script&lang=js&"
export * from "./CustomerPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPersonalData.vue?vue&type=style&index=0&id=daa4d432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa4d432",
  null
  
)

export default component.exports